import React, { useContext, useMemo, useState } from "react";

type TokenContext = {
  token: string | null;
  setToken: (token: string | null) => void;
};

const defaultTokenContext: TokenContext = {
  token: null,
  setToken: () => {},
};

const tokenContext = React.createContext<TokenContext>(defaultTokenContext);

tokenContext.displayName = "TokenContext";

const STORAGE_KEY = "fsda";

export function tokenGetSafe(): string | null {
  try {
    if (typeof window === "undefined") {
      return null;
    } else {
      return localStorage.getItem(STORAGE_KEY);
    }
  } catch (err) {
    return null;
  }
}

export function tokenSetSafe(token: string | null) {
  try {
    if (typeof window === "undefined") {
      return;
    } else {
      if (token === null) {
        localStorage.removeItem(STORAGE_KEY);
      } else {
        localStorage.setItem(STORAGE_KEY, token);
      }
    }
  } catch (err) {
    return;
  }
}

export const TokenProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [token, setToken] = useState<string | null>(tokenGetSafe());

  const memoedContextValues = useMemo<TokenContext>(() => {
    return {
      token,
      setToken: (token: string | null) => {
        setToken(token);
        tokenSetSafe(token);
      },
    };
  }, [token, setToken]);

  return (
    <tokenContext.Provider value={memoedContextValues}>
      {children}
    </tokenContext.Provider>
  );
};

export function useToken() {
  return useContext(tokenContext);
}
